import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LogicielCaisseAuthService } from 'app/services/logiciel-caisse/logiciel-caisse-auth.service';

/**
 * Ne pas se fier au cache `needs_setup` (faux positifs → onboarding à tort).
 * Toujours tenter ensureAuthenticatedSession avant de rediriger vers le setup.
 */
@Injectable({ providedIn: 'root' })
export class LogicielCaisseAuthGuard implements CanActivate {
  constructor(
    private readonly lcAuth: LogicielCaisseAuthService,
    private readonly router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const returnUrl = state.url;

    return this.lcAuth.ensureAuthenticatedSession().pipe(
      switchMap((ok) => {
        if (ok) {
          return of(true as boolean | UrlTree);
        }
        this.lcAuth.invalidateAccessCache();
        return this.lcAuth.bootstrap({ forceRefresh: true }).pipe(
          map((status) => {
            if (status === 'ready' && this.lcAuth.isAuthenticated()) {
              return true;
            }
            if (status === 'needs_password') {
              return this.router.createUrlTree(['/tiers/acces-logiciel-caisse/add'], {
                queryParams: { returnUrl },
              });
            }
            return this.router.createUrlTree(['/tiers/acces-logiciel-caisse/onboarding'], {
              queryParams: { returnUrl },
            });
          }),
          catchError(() =>
            of(
              this.router.createUrlTree(['/tiers/acces-logiciel-caisse/onboarding'], {
                queryParams: { returnUrl },
              })
            )
          )
        );
      }),
      catchError(() =>
        of(
          this.router.createUrlTree(['/tiers/acces-logiciel-caisse/onboarding'], {
            queryParams: { returnUrl },
          })
        )
      )
    );
  }
}
